import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from '../../utils/BackgroundJobs';
import SalesVatOnlyPostMutation from '../../graphql/mutations/salesLedger/SalesVatOnlyPostMutation.graphql';
import SalesVatOnlyPostingPreview from '../../graphql/entities/salesLedger/SalesVatOnlyPostingPreview';
import SalesVatOnlyTransactions from '../../graphql/entities/salesLedger/SalesVatOnlyTransactions';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';
import { DocumentStatus, ISalesVatOnly } from '../../graphql/schema/p4types';

const displayPreview: (vatOnly: ISalesVatOnly) => boolean = (vatOnly) => {
  if (vatOnly && vatOnly.documentStatus) {
    return vatOnly.documentStatus === DocumentStatus.Draft || vatOnly.documentStatus === DocumentStatus.Released;
  }
  return false;
};

const displayPosted: (vatOnly: ISalesVatOnly) => boolean = (vatOnly) => {
  if (vatOnly && vatOnly.documentStatus) {
    return vatOnly.documentStatus === DocumentStatus.Posted;
  }
  return false;
};

const canBePosted: (vatOnly: ISalesVatOnly) => boolean = (vatOnly) => {
  if (vatOnly && vatOnly.documentStatus) {
    return vatOnly.documentStatus === DocumentStatus.Draft || vatOnly.documentStatus === DocumentStatus.Released;
  }
  return false;
};

const postVatOnly: (props: any) => void = (props) => {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(SalesVatOnlyPostMutation, input, props, 'back', 'Post Vat', null);
};

const SALES_VAT_ONLY_POSTING_PREVIEW = createPostingPreview(SalesVatOnlyPostingPreview);
const SALES_VAT_ONLY_POSTED_TRANSACTIONS = createPostedTransactions(SalesVatOnlyTransactions);

export const formActions = [
  {
    description: 'Preview Postings',
    triggerModal: {
      modalContent: SALES_VAT_ONLY_POSTING_PREVIEW,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Postings/salesLedger/SalesVatOnly',
        forceReadOnly: true,
      },
    },
    performSave: true,
    saveMessage: 'Nominal/VAT Postings Preview',
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPreview,
  },
  {
    description: 'View Transactions',
    triggerModal: {
      modalContent: SALES_VAT_ONLY_POSTED_TRANSACTIONS,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Transactions/salesLedger/SalesVatOnly',
        forceReadOnly: true,
      },
    },
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPosted,
  },
  {
    description: 'Post Vat',
    component: PostSelectButton,
    performSave: true,
    fn: postVatOnly,
    individualButton: true,
    saveMessage: 'Vat Posted',
    condition: canBePosted,
  },
];
